import React, { Component } from "react";
import { StyleSheet, View, TextInput, Text } from "react-native";
//import { Picker } from "@react-native-community/picker";

function InputLayout(props) {
  return (
    <View style={styles.container}>
      <TextInput
        maxLength={2}
        style={styles.label}
        placeholder={props.placeholder}
        onChangeText={props.onChangeText}
        value={props.value}
        keyboardType='numeric'
        autoCompleteType={
          props.autoCompleteType !== null ? props.autoCompleteType : "off"
        }></TextInput>
    </View>
  );
}

const styles = StyleSheet.create({
  label: {
    textAlign: "center",
    fontFamily: "Nunito-Regular",
    color: "#3E4672",
    fontSize: 17,
    marginTop: 4,
    marginLeft: 10,
    marginRight: 10,
  },
  container: {
    borderStyle: "solid",
    borderWidth: 0.3,
    borderColor: "#ACACAC",
    alignSelf: "center",
    backgroundColor: "#fff",
    borderRadius: 15,
    marginBottom: 20,
    marginTop: 20,
    maxWidth: 200,
  },
});

export default InputLayout;
